<template>
    <div>
        <vTable :data="datalist" border :columns="columnsList"></vTable>
    </div>
</template>

<script>
import {
    HttpLimitOrgAlert
} from "@/service/setting.js";
import { mapState, mapGetters } from "vuex";

export default {
    props:['actived'],
    data(){
        return {
            datalist:[],
        }
    },
    created(){
        HttpLimitOrgAlert({
            id:this.actived
        }).then(res=>{
            this.datalist = res.data
        },err=>{

        })
    },
    computed:{
         ...mapGetters("dictionary", [
            "getSelfmanageorgList",
        ]),
        columnsList() {
			return [
				{
                    title:  this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'organizationName',
                    render: (h, { row }) => {
                        let clientItem = this.getSelfmanageorgList.filter(item => {
                            return row.organizationId === item.value
                        })[0];
                        return <div>{clientItem ? clientItem.label : '--'}</div>
                    }
                },
                {
                    title: this.$t("global.common.warehouse", { defaultValue: "仓库"}),
                    key: 'orgWarehouseCode',
				},
				{
					title:  this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
					key: 'carrierCode',
				},
                {
					title:  'SKU',
					key: 'erpsku',
				},
                {
					title: this.$t('global.common.source_number',{defaultValue:'来源单号'}),
					key: 'sourceNo',
				},
                {
					title:  this.$t('fbb.alloment.date', { defaultValue: "日期" }),
					key: 'capacityDate',
				},
                {
					title:  this.$t('', { defaultValue: '占用数量' }),
                    key:'qtyRequest',
                    // render: (h, { row }) => {
                    //     return <div>
                    //         {row.capacity - row.lastCapacity}
                    //         </div>
                    // }
				},
                {
					title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
					key: 'updatedAt',
				},
			]
		},
    },
    methods:{
        
    }
}
</script>
